import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private _storage: Storage | null = null;

  constructor(private storage: Storage) {
    this.ready();
  }

  /**
   * readies storage for use. Creates a storage instance.
   */
  async ready(): Promise<void> {
    if (!this._storage) {
      // make sure we don't already have a storage instance created
      await this.storage.defineDriver(CordovaSQLiteDriver); // register sqlLite as our storage driver
      const storage = await this.storage.create();
      this._storage = storage;
    }
  }

  /**
   * Sets a key/value pair in storage
   *
   * @param key - key to set
   * @param value - value to set
   */
  public async set(key: string, value: any) {
    this._storage?.set(key, value);
  }

  /**
   * Gets a value from storage for the given key;
   *
   * @param key - the key of the value to get
   */
  public async get(key: string) {
    return await this._storage.get(key);
  }

  /**
   * Clears the entire storage.
   */
  public async clear() {
    await this._storage.clear();
  }

  /**
   * Removes an item from storage
   *
   * @param key - key of the value to remove
   */
  public async remove(key: string) {
    await this._storage.remove(key);
  }
}
